import type { PopupData } from 'webapp-types';

import BillingAiCreditsUpdateComponent from 'webapp/components/billing/ai-credits/update';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPopupAiCreditsPurchaseComponent extends PopupInnerModalComponent<PopupData.Billing.QuantifiableAddonPurchase> {
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Ai" @size="lg" />
			Extra AI credits
		</div>
		<div class="content">
			<BillingAiCreditsUpdateComponent
				@onClose={{this.close}}
				@origin={{this.popupData.origin}}
			/>
		</div>
	</template>
}
